import { AfterViewInit, Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { initFlowbite } from 'flowbite';
import { RouteGuardService } from './core/route-guard.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'RebatiFitness';

  constructor(
    private translateService: TranslateService,
    private renderer: Renderer2,
    private routeGuardService: RouteGuardService
  ) {}

  ngOnInit(): void {
    console.log('=== APP COMPONENT INIT ===');
    console.log('App component initialized');
    this.translateService.setDefaultLang('fa');
    // RouteGuardService will handle initial route checking
  }

  ngAfterViewInit() {
    // Initialize Telegram WebApp first
    if (window?.Telegram?.WebApp) {
      window.Telegram.WebApp.ready();

      // Give Telegram WebApp a moment to fully initialize before setting up theme
      setTimeout(() => {
        this.setupTheme();
      }, 50);
    } else {
      // Not in Telegram, use system theme and listen for changes
      this.applySystemTheme();
      this.setupSystemThemeListener();
    }
  }

  private setupTheme(): void {
    const webApp = window?.Telegram?.WebApp;

    // Check if colorScheme is actually available and has a value
    if (!webApp || typeof webApp.colorScheme !== 'string' || !webApp.colorScheme) {
      // Not in Telegram mini app, use system theme
      this.applySystemTheme();
      return;
    }

    // Apply initial Telegram theme (don't remove existing class if already correct)
    this.applyTelegramTheme();

    // Listen for theme changes
    webApp.onEvent('themeChanged', () => {
      this.applyTelegramTheme();
    });
  }

  private applyTelegramTheme(): void {
    const webApp = window?.Telegram?.WebApp;
    const colorScheme = webApp?.colorScheme;
    const isDarkMode = colorScheme === 'dark';
    const hasDarkClass = document.documentElement.classList.contains('dark');

    // Only update if the state is different from what's currently applied
    if (isDarkMode && !hasDarkClass) {
      this.renderer.addClass(document.documentElement, 'dark');
    } else if (!isDarkMode && hasDarkClass) {
      this.renderer.removeClass(document.documentElement, 'dark');
    }

    // Always set header color to match
    if (isDarkMode) {
      webApp?.setHeaderColor('#000000');
    } else {
      webApp?.setHeaderColor('#f3f4f6');
    }
  }

  private applySystemTheme(): void {
    // Check localStorage first, then fall back to system preference
    const storedTheme = localStorage.getItem('color-theme');

    if (storedTheme === 'dark') {
      this.renderer.addClass(document.documentElement, 'dark');
    } else if (storedTheme === 'light') {
      this.renderer.removeClass(document.documentElement, 'dark');
    } else {
      // No stored preference, use system theme
      if (window?.matchMedia('(prefers-color-scheme: dark)').matches) {
        this.renderer.addClass(document.documentElement, 'dark');
      } else {
        this.renderer.removeClass(document.documentElement, 'dark');
      }
    }
  }

  private setupSystemThemeListener(): void {
    // Only listen to system theme changes if user hasn't set a manual preference
    const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

    // Listen for changes in system theme preference
    darkModeMediaQuery.addEventListener('change', (e) => {
      // Only apply system theme if user hasn't manually set a preference
      const storedTheme = localStorage.getItem('color-theme');

      if (!storedTheme) {
        // No manual preference, follow system theme
        if (e.matches) {
          this.renderer.addClass(document.documentElement, 'dark');
        } else {
          this.renderer.removeClass(document.documentElement, 'dark');
        }
      }
    });
  }
}
